import React, { useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { AppContext } from 'contexts';
import { makeStyles, Box, Modal, Typography, Button } from '@material-ui/core';
import { AgoraRTCClient } from 'utils/agora';

const useStyles = makeStyles((theme) => {
  return {
    confirmationModal: {
      width: 300,
      position: 'relative',
      top: '20%',
      marginLeft: 'auto',
      marginRight: 'auto',
      alignContent: 'center',
      backgroundColor: 'white',
      padding: 30,
      animation: 'slide-down .2s ease-in',
      '@media (max-width: 767px)': {
        top: 101,
      },
    },
    title: {
      marginBottom: 20,
    },
    button: {
      marginRight: 20,
    },
  };
});
function ConfirmationModal() {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const {
    listing,
    listingId,
    callBroker,
    confirmCallModalOpen,
    closeConfirmCallModal,
    startCall,
    isJoinedSession,
    isCallOngoing,
    sendDataToVRServer,
    setCallOngoing,
    setModalMessage,
    setIsJoinedSession,
    setSessionId,
    ringtone,
  } = appContext;
  const broker = listing ? listing.broker : null;
  const brokerFirstName = broker ? broker.firstname : '';
  const brokerLastName = broker ? broker.lastname : '';
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    // clear timer when the call is cancelled or broker join the session
    if ((isJoinedSession || !isCallOngoing) && timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
      ringtone.stop();
    }
  }, [isJoinedSession, isCallOngoing, ringtone]);

  const handleConfirmCall = async () => {
    try {
      closeConfirmCallModal();

      const session_id = uuidv4();
      setSessionId(session_id);
      const agoraToken = await callBroker(session_id);

      await AgoraRTCClient.joinChannel(session_id, agoraToken);

      startCall();
      ringtone.play();
      const brokerNotAvailalbeTimer = setTimeout(() => {
        AgoraRTCClient.leave();
        setCallOngoing(false);
        setModalMessage('broker-not-available');
        setIsJoinedSession(false);
        ringtone.stop();
      }, 20 * 1000);
      setTimeoutId(brokerNotAvailalbeTimer);

      sendDataToVRServer({
        type: 'invite-user',
        content: {
          sessionId: session_id,
          invitedUserId: listing.broker.id,
          sessionInfo: {
            listing_id: listingId,
            broker_id: listing.broker.id,
            source: 'web',
          },
        },
      });
    } catch (error) {
      setCallOngoing(false);
    }
  };
  return (
    <div>
      <Modal
        open={confirmCallModalOpen}
        onClose={closeConfirmCallModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className={classes.confirmationModal}>
          <Typography className={classes.title}>
            {`Prêt à appeler le courtier ${brokerFirstName} ${brokerLastName} et faire une visite virtuelle en direct?`}
          </Typography>
          <Button
            className={classes.button}
            size='small'
            variant='contained'
            onClick={closeConfirmCallModal}
          >
            Non
          </Button>
          <Button
            size='small'
            color='primary'
            variant='contained'
            onClick={handleConfirmCall}
          >
            Oui
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
export default ConfirmationModal;
